import { render, staticRenderFns } from "./Extrapolate.vue?vue&type=template&id=6c5b9078&"
import script from "./Extrapolate.vue?vue&type=script&lang=js&"
export * from "./Extrapolate.vue?vue&type=script&lang=js&"
import style0 from "./Extrapolate.vue?vue&type=style&index=0&id=6c5b9078&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports